module.exports = __webpack_public_path__ + "static/media/Comm & Data Networks.983b884b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ECE/Comm & Data Networks.pdf
// module id = 110
// module chunks = 0